import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';

import configRequest from '../configRequest';

export interface AddTOTPMethodData {
	name: string;
	code: string;
}

export interface AddTOTPMethodResponse {
	backup_codes: string[];
}

const addTOTPMethod = configRequest<AddTOTPMethodResponse, AddTOTPMethodData>({
	requestPrefix: 'mfa/addTOTPMethod',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.MFA.TOTP.ADD_TOTP_METHOD(),
		method: HTTP_METHODS_ENUM.POST,
		data,
	}),
});

export default addTOTPMethod;
